import { motion } from 'framer-motion';

const positions = {
    tiktok: "top-6 right-2 rotate-[-90deg] z-100",
}

export const NotificationPermissionPointer = () => {
    return (
        <motion.div
            initial={{ x: 0 }}
            animate={{ x: [0, 5, 0] }}
            transition={{ duration: 1.35, ease: "easeInOut", repeat: Infinity }}
            className={`text-4xl absolute ${positions["tiktok"]}`}
        >
            👉
        </motion.div>
    );
};

